enum LessonAssignmentTranslationVariant {
  activitySuccessfullyAddedTo = 'activitySuccessfullyAddedTo',
  addActivity = 'addActivity',
  addActivityTo = 'addActivityTo',
  addClassesAndStudents = 'addClassesAndStudents',
  addLessonsAndActivities = 'addLessonsAndActivities',
  lessonsAndActivities = 'lessonsAndActivities',
  allStudents = 'allStudents',
  assignLesson = 'assignLesson',
  assignment = 'assignment',
  dayAssignment = 'dayAssignment',
  assignmentDueDate = 'assignmentDueDate',
  assignmentsFor = 'assignmentsFor',
  assignmentStartDate = 'assignmentStartDate',
  audioInstructions = 'audioInstructions',
  cancel = 'cancel',
  collapse = 'collapse',
  edit = 'edit',
  editAssignment = 'editAssignment',
  pleaseSelectClassroom = 'pleaseSelectClassroom',
  pleaseSelectClassroomFirst = 'pleaseSelectClassroomFirst',
  recordAudio = 'recordAudio',
  removeActivites = 'removeActivites',
  reviewAndAssign = 'reviewAndAssign',
  selectClassesAndStudents = 'selectClassesAndStudents',
  selectTheClassesTitle = 'selectTheClassesTitle',
  teacherInstructions = 'teacherInstructions',
  typeYourInstructionsHere = 'typeYourInstructionsHere',
  assign = 'assign',
  unassign = 'unassign',
  unassignLesson = 'unassignLesson',
  uploadFromDevice = 'uploadFromDevice',
  noClassesToAssignHeader = 'noClassesToAssignHeader',
  noClassesToAssignTrialHeader = 'noClassesToAssignTrialHeader',
  noClassesToAssignTrialUser = 'noClassesToAssignTrialUser',
  noClassesToAssignPLI1 = 'noClassesToAssignPLI1',
  noClassesToAssignPLI2 = 'noClassesToAssignPLI2',
  noClassesToAssignManagedUser = 'noClassesToAssignManagedUser',
  reorder = 'reorder',
  activityType = 'activityType',
  thisWeeksAssignments = 'thisWeeksAssignments',
  assignAnotherDay = 'assignAnotherDay',
  assignmentTitle = 'assignmentTitle',
  classesAndStudentsDetails = 'classesAndStudentsDetails',
  classesAndStudents = 'classesAndStudents',
  instructions = 'instructions',
  duration = 'duration',
  selectClassroom = 'selectClassroom',
  selectStudents = 'selectStudents',
  assignedTo = 'assignedTo',
  dueDate = 'dueDate',
  teachingInstructions = 'teachingInstructions',
  titleIsRequired = 'titleIsRequired',
  eachAssignmentShouldActivity = 'eachAssignmentShouldActivity',
  assignmentStartDateRequired = 'assignmentStartDateRequired',
  assignmentDueDateRequired = 'assignmentDueDateRequired',
  unassignSuccessful = 'unassignSuccessful',
  warmup = 'warmup',
  practice = 'practice',
  extras = 'extras',
  assignmentCreatedSuccess = 'assignmentCreatedSuccess',
  expand = 'expand',
  durationAlertTitle = 'durationAlertTitle',
  durationAlertBody = 'durationAlertBody'
}

export default LessonAssignmentTranslationVariant;
